import type { ReactNode } from "react";

export function LegalPageLayout({
	tag,
	title,
	updated,
	children,
}: {
	tag: string;
	title: string;
	updated: string;
	children: ReactNode;
}) {
	return (
		<div className="page-wrap py-12">
			<div className="mx-auto flex max-w-2xl flex-col gap-10">
				<div>
					<p className="sec-tag">{tag}</p>
					<h1 className="display-title text-[clamp(32px,4vw,48px)] leading-none text-foreground">
						{title}
					</h1>
					<p className="mt-3 text-xs text-muted-foreground">{updated}</p>
				</div>
				<div className="flex flex-col gap-8">{children}</div>
			</div>
		</div>
	);
}

export function LegalSection({
	heading,
	children,
}: {
	heading: string;
	children: ReactNode;
}) {
	return (
		<section className="flex flex-col gap-3">
			<h2 className="text-lg font-semibold text-foreground">{heading}</h2>
			<div className="flex flex-col gap-3 text-sm leading-relaxed text-muted-foreground">
				{children}
			</div>
		</section>
	);
}

export function LegalList({ items }: { items: string[] }) {
	return (
		<ul className="flex flex-col gap-1.5 pl-5 list-disc marker:text-primary-accessible">
			{items.map((item) => (
				<li key={item}>{item}</li>
			))}
		</ul>
	);
}
